import React from 'react'
import infoIcon from 'img/information.svg'

export const InfoIcon = (
  <img className='info-icon d-print-none' src={infoIcon} />
)
